import React, { useEffect } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  checkMyrCreatedTransaction,
  postMyrCreateTransaction,
} from "../redux/actions/postQrInitManual";
import { useNavigate, useParams } from "react-router-dom";
import SuccessMessage from "./SuccessMessage";
import SpinerIndicatorWhiteBg from "./SpinerIndicatorWhiteBg";
import getVerifyManualTransaction, {
  getVerifyManualTransactionMyr,
} from "../redux/actions/getVerifyManualTransaction";
import MainWrapper from "./MainWrapper";
import expiredQr from "../assets/expiredQr.jpg";

const StyleWrapper = styled.div`
  background: white;
  padding: 10px;
  border-radius: 12px;
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: "HarmonyRegular";
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  .ant-spin-text {
    margin-top: 20px;
  }
  // @media (max-width: 1024px) {
  //   width: 90%;
  // }
`;

const MyrSuccessScreen = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const {
    isLoading,
    error,
    data: verifyData,
  } = useSelector((state) => state.getVerifyManualTransactionReducer);

  const {
    data: trnxCheckData,
    error: trnxCheckError,
    isLoading: trxCheckLoading,
  } = useSelector((state) => state.getQrManualCheckReducer);

  const {
    data: qrInitData,
    error: qrInitError,
    isLoading: qrInitLoading,
  } = useSelector((state) => state.postQrInitManualReducer);

  useEffect(() => {
    // if (verifyData) {
    let checkmyrTrnxParams = {
      transactionId: verifyData.trxRef,
      userId: verifyData.merchantId,
    };
    dispatch(
      checkMyrCreatedTransaction(params.id, navigate, params.userId, params.method)
    );
    // } else {
    // dispatch(getVerifyManualTransactionMyr(params.id));
    // }
  }, []);

  // ---------------REDIRECT BACK TO MERCHANT SITE--------------
  let getRedirectionUrl = localStorage.getItem("redirectionUrl");
  useEffect(() => {
    if (trnxCheckData) {
      if (getRedirectionUrl !== null) {
        setTimeout(() => {
          window.open(getRedirectionUrl || trnxCheckData.redirectUrl, "_self");
          localStorage.removeItem("redirectionUrl");
        }, 3000);
      } else if (trnxCheckData?.redirectUrl) {
        setTimeout(() => {
          window.open(trnxCheckData.redirectUrl, "_self");
        }, 3000);
      } else if (trnxCheckData?.siteUrl) {
        setTimeout(() => {
          window.open(trnxCheckData.siteUrl, "_self");
        }, 3000);
      }
    }
  }, [trnxCheckData]);

  // -------------IF GET ERROR THEN GO BACK TO PAGE----------
  // useEffect(() => {
  //   if (error || trnxCheckError) {
  //     navigate(`/${params?.method}/${params.id}`);
  //   }
  // }, [error, trnxCheckError]);

  const successORerror = () => {
    if (trnxCheckData?.status == "02_Paid") {
      return (
        <StyleWrapper>
          <SuccessMessage width={"100%"} height={"40%"} />
          <h5 style={{ color: "green" }}>Payment Successful</h5>
          <p className="text-center mt-2" style={{ fontSize: 14 }}>
            Please be patient while we redirect you back to merchant’s site
          </p>
          <p style={{ fontSize: 13 }}>
            <b>Reference number: </b>
            {trnxCheckData?.qrCodeTransactionId}
          </p>
        </StyleWrapper>
      );
    } else if (trnxCheckData?.status == "00_Initiated") {
      return (
        <StyleWrapper>
          <img src={expiredQr} width="100%" height="100%" />
          <h5 style={{ color: "red" }}>Payment Error</h5>
          <p className="text-center mt-2" style={{ fontSize: 14 }}>
            Please contact support with the reference number below if payment
            was made
          </p>
          <p style={{ fontSize: 13 }}>
            <b>Reference number: </b>
            {trnxCheckData?.qrCodeTransactionId}
          </p>
        </StyleWrapper>
      );
    } else {
      return (
        <StyleWrapper>
          <img src={expiredQr} width="100%" height="100%" />
          <h5 style={{ color: "red" }}>Payment Error</h5>
          <p className="text-center mt-2" style={{ fontSize: 14 }}>
            Please contact support with the reference number below if payment
            was made
          </p>
          <p className=" mt-2" style={{ fontSize: 14, color:'red' }}>
            {trnxCheckData?.message}
          </p>
        </StyleWrapper>
      );
    }
  };

  return (
    <MainWrapper>
    <div className="d-flex justify-content-center align-items-center position-absolute" style={{ height: "100vh", width: '100%' }}>
      {trxCheckLoading || isLoading || qrInitLoading ? (
        <SpinerIndicatorWhiteBg fontSize="15px" color="#000" />
      ) : (
        successORerror()
      )}
    </div>
    </MainWrapper>
  );
};

export default MyrSuccessScreen;
